
import React from 'react'
import Heading from './Heading'
import Paragraph from './Paragraph'

/**
 * Title component.
 */

export default function Title({ text, subtext, size = 1 }) {
  return <div>
    <Heading size={size}>{text}</Heading>
    <Paragraph marginTop={size == 1 ? 0 : 2} muted>{subtext}</Paragraph>
  </div>
} 